import { useAtom } from "jotai";

import { skipAnalysisLayoutAnimationsVar } from "@/variables/globalVar";

export function useSkipAnalysisLayoutAnimations() {
  return useAtom(skipAnalysisLayoutAnimationsVar);
}
